

import OGFormularModel from '@/components/models/OGFormularModel.vue'
import TCOScoreModel from '@/components/models/TCOScoreModel.vue'

export default class TGProductModel {
  formular: OGFormularModel = new OGFormularModel()
  score: TCOScoreModel = new TCOScoreModel()
}
